/**
 * oz-animations.js
 * Scroll-triggered fade-in-up for elements with class "oz-fade-up".
 * Adds "oz-visible" when the element enters the viewport (fires once).
 * Respects prefers-reduced-motion — CSS handles the no-motion fallback.
 */
(function () {
  'use strict';

  if (!window.IntersectionObserver) return; // old browsers: elements stay visible (CSS shows them)

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oz-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
  );

  function init(root) {
    (root || document).querySelectorAll('.oz-fade-up:not(.oz-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify theme editor: re-observe when a section is loaded/reordered
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:reorder', function () { init(); });
  }
})();
